import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Avatar from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Avatar';

const styles = () => ({
  root: {},
});

const ProfileImage = ({
  className,
  classes,
  link,
  alt,
}) => {
  return (
    <Avatar
      className={classNames(classes.root, className)}
      alt={alt}
      src={link.attr('url')}
    />
  );
};

ProfileImage.defaultProps = {
  className: '',
  alt: 'Profile image',
};

ProfileImage.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  link: PropTypes.object.isRequired,
  alt: PropTypes.string,
};

export default withStyles(styles)(ProfileImage);
